import { CSSProperties } from 'react';
import { Theme } from '@mui/material/styles';
import { MATCH_TYPE } from '@/pages/Candidate/view/utils/DecisionTreeDiagram/constants';
import { BG_COLOR_KEY_MAPPING } from '@/pages/Candidate/view/utils/DecisionTreeDiagram/nodes/ColorKeyPerMatch/constants';
import { MatchTypeValue } from '../../types';

export const getNodeStyles = (value: MatchTypeValue, theme: Theme): CSSProperties => {
  const { dark_amber, dark_green, dark_grey, light_grey, red } = BG_COLOR_KEY_MAPPING;

  if (MATCH_TYPE.exact.includes(value)) return dark_green.styles(theme);
  if (MATCH_TYPE.partial.includes(value)) return dark_amber.styles(theme);
  if (MATCH_TYPE.mismatch.includes(value)) return red.styles(theme);
  if (MATCH_TYPE.unknown.includes(value)) return dark_grey.styles(theme);

  return light_grey.styles(theme);
};
